import React, {Component} from 'react'
import RGL, {WidthProvider} from 'react-grid-layout';
import {Button, Container, Row, Col, Card, CardHeader, CardBody} from 'reactstrap'
import {Query, Mutation} from 'react-apollo'

import Undertime from './Undertime'
import Agenda from "./Agenda";
import ProjectsLast30DaysChart from './ProjectsLast30DaysChart'
import DashboardWidgetsSelector from './DashboardWidgetsSelector'
import WhosOff from './WhosOff'
import NewProjects from './NewProjects'
import QUERY from '../../../queries/user_dashboard'
import MUTATION from '../../../queries/server/mutations/upsert_user_dashboard_widgets'
import LOCAL_MUTATION from '../../../queries/client_side/mutations/toggle_dashboard_widget'

const GridLayout = WidthProvider(RGL)

const widgets = {
  agenda: (id, settings, user_id) => {
    return (
      <Card key={id} data-grid={settings}>
          <CardHeader>Agenda</CardHeader>
          <CardBody style={{overflow: 'auto'}}>
            <Agenda user_id={user_id}/>
          </CardBody>
      </Card>
    )
  },
  'project-time-chart': (id, settings, user_id) => {
    return (
      <Card key={id} data-grid={settings}>
          <CardHeader>Project Time (Last 30 Days)</CardHeader>
          <CardBody> 
              <ProjectsLast30DaysChart/>
          </CardBody>
      </Card>
    )
  },
  undertime: (id, settings, user_id) => {
    return (
      <Card key={id} data-grid={settings}>
          <CardHeader>W/C Undertime</CardHeader>
          <CardBody style={{overflow: 'auto'}}>
            <Undertime user_id={user_id}/>
          </CardBody>
      </Card>
    )
  },
  'annual-leave-current-week': (id, settings, user_id) => {
    return (
      <Card key={id} data-grid={settings}>
          <CardHeader>Who's Off (This Week)</CardHeader>
          <CardBody style={{overflow: 'auto'}}>
            <WhosOff />
          </CardBody>
      </Card>
    )
  },
  'new-projects': (id, settings, user_id) => {
    return (
      <Card key={id} data-grid={settings}>
          <CardHeader>New Projects (Last 7 Days)</CardHeader>
          <CardBody style={{overflow: 'auto'}}>
            <NewProjects/>
          </CardBody>
      </Card>
    )
  },
}

export default class FluidDashboard extends Component {

  static getDerivedStateFromProps(props, state){

    const {user} = JSON.parse(sessionStorage.getItem('user'))

    return {
        user
    }
}


  render() {

    return (
      <Query query={QUERY} variables={{user_id: this.state.user.user_id}} fetchPolicy="network-only">
        {({loading, error, data}) => {

          if(loading) return <h1>Loading...</h1>

          console.log('data', data)

          return (
            <div>
              <div className="d-flex flex-row justify-content-between align-items-center pt-3 pl-2 pr-2 pb-0">
                <h1>Dashboard</h1>
                <Mutation mutation={LOCAL_MUTATION}>
                  {(toggleWidgetFunc) => (
                    <DashboardWidgetsSelector
                      selectedWidgets={data.user.dashboard_widgets}
                      onChange={(widget, toggle) => toggleWidgetFunc({variables: {widget, toggle, user_id: this.state.user.user_id}})}
                    />
                  )}
                </Mutation>
                
              </div>
              <Mutation mutation={MUTATION}>
                {(upsertDashboardWidgetsFunc, mut) => (
                  <GridLayout
                    className="layout"
                    cols={12}
                    rowHeight={150}
                    onLayoutChange={(layout) => {
                      upsertDashboardWidgetsFunc({
                        variables: {
                          user_id: this.state.user.user_id,
                          widgets: layout.map(({i, x, y, w, h}) => {
                            return {
                              id: i,
                              settings: JSON.stringify({x, y, w, h})
                            }
                          })
                        }
                      })
                        .then((res) => {
                          console.log(res)
                        })
                    }}
                  >
                    {data.user.dashboard_widgets.map(({id, settings}) => {
                      return widgets[id](id, JSON.parse(settings), this.state.user.user_id)
                    })}
                  </GridLayout>
                )}
              </Mutation>
            </div>
          )
        }}
      </Query>
    )

  }
}